import { render, staticRenderFns } from "./assetQuery.vue?vue&type=template&id=580ddfad&scoped=true"
import script from "./assetQuery.vue?vue&type=script&lang=js"
export * from "./assetQuery.vue?vue&type=script&lang=js"
import style0 from "./assetQuery.vue?vue&type=style&index=0&id=580ddfad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ddfad",
  null
  
)

export default component.exports